<template>
    <!--   <div class="sa-tab-scroll"> -->
    <!--     <b-tabs id="tabsRsaAccettazioneEdit" ref="tabsRsaAccettazioneEdit" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
        <b-tab title="Anagrafica" id="tbAnagrafica"> -->
    <!-- <div class="sa-tab-scroll">
        <div class="sa-flexbox" style="padding-bottom: 20px"> -->
    <div style="height: 100%; overflow: auto; margin-left: 5px; margin-right: 5px">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <span class="sa-flexbox-body-title">Scheda ospite</span>
                    <b-button v-show="btnModificaAccettazione && isPageGestioneOspite" size="sm" variant="outline-secondary outline-primary-noborder sa-margin-right float-sm-right" @click="onClickModificaAccettazione" class="mb-2">
                        <font-awesome-icon icon="pen" />
                        Modifica
                    </b-button>
                    <b-button v-show="btnSalvaModificaAccettazione" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickSalvaModificheAccettazione" class="mb-2">
                        <i class="fas fa-plus"></i>
                        Salva
                    </b-button>
                    <b-button v-show="btnAnnullaModificaAccettazione" size="sm" variant="outline-danger outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAnnullaModificaAccettazione" class="mb-2">
                        <font-awesome-icon icon="trash" />
                        Annulla
                    </b-button>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-card class="sa-card sa-card-border" header="Struttura - Presidio" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Struttura</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneStruttura.denominazione }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.codiceStruttura" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceStruttura" text-field="denominazione" :options="strutturaOptions" @change="onChangeStruttura"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Presidi</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazionePresidio.denominazione }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.idPresidio" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id" text-field="denominazione" :options="presidiOptions" @change="onChangePresidio"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Regime</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.regime }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.regime" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="codice" text-field="descrizione" :options="regimiOptions"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Setting</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.settingDescrizione }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.settingCodice" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="codice" text-field="setting" :options="settingsPresidiOptions" @change="onChangeSettingCodice"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-card class="sa-card sa-card-border" header="Anagrafica" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label htmlFor="rsaGestioneOspitiEditComponentAccettazioneAnagraficaIdentificativo" class="sa-label-data">Identificativo</label>
                                <span>{{ jsonData.accettazioneAnagrafica.identificativo }}</span>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Cognome</label>
                                <span>{{ jsonData.accettazioneAnagrafica.cognome }}</span>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Nome</label>
                                <span>{{ jsonData.accettazioneAnagrafica.nome }}</span>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Data di nascita</label>
                                <span>{{ formatDate(jsonData.accettazioneAnagrafica.dataNascita) }}</span>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Provincia di nascita</label>
                                <span>{{ jsonData.accettazioneAnagrafica.provinciaNascita }}</span>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Comune di nascita</label>
                                <span>{{ comuneNascita }}</span>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Sesso</label>
                                <span>{{ jsonData.accettazioneAnagrafica.sesso }}</span>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-card class="sa-card sa-card-border" header="Residenza" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Provincia</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.provinciaResidenza }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.accettazioneAnagrafica.provinciaResidenza" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="sigla" text-field="provincia" :options="provinceResidenzaOptions" @change="onChangeProvinciaResidenza" required></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Comune</label>
                                <span v-if="isAccettazioneCampiEdit">{{ comuneResidenza }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat" text-field="comune" :options="comuniResidenzaOptions" @change="onChangeComuneResidenza" required></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">CAP</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.capResidenza }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.capResidenza"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Indirizzo</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.indirizzoResidenza }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.indirizzoResidenza"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-card class="sa-card sa-card-border" header="Domicilio" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Provincia</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.provinciaDomicilio }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.accettazioneAnagrafica.provinciaDomicilio" class="mb-2 mr-sm-2 mb-sm-0" :options="provinceDomicilioOptions" :value="null" value-field="sigla" text-field="provincia" @input="onInputProvinciaDomicilio" required></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Comune</label>
                                <span v-if="isAccettazioneCampiEdit">{{ comuneDomicilio }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat" text-field="comune" :options="comuniDomicilioOptions" @input="onInputComuneDomicilio" required></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">CAP</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.capDomicilio }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.capDomicilio"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Indirizzo</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.indirizzoDomicilio }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.indirizzoDomicilio"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-card class="sa-card sa-card-border" header="ASL di residenza" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Codice A.S.L.</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslResidenzaCodice }} </span>
                                <b-form-input v-else v-model="jsonData.accettazioniAsl.aslResidenzaCodice"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">A.S.L.</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslResidenzaDenominazione }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioniAsl.aslResidenzaDenominazione"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Ambito</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslResidenzaAmbito }}</span>
                                <b-form-select v-else v-model="jsonData.accettazioniAsl.aslResidenzaAmbito" :options="ambitiAslResidenzaOptions" text-field="text" value-field="value"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Distretto</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslResidenzaDistretto }}</span>
                                <b-form-select v-else v-model="jsonData.accettazioniAsl.aslResidenzaDistretto" :options="distrettiAslResidenzaOptions" value-field="codiceDistretto" text-field="descrizione"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-card class="sa-card sa-card-border" header="ASL di domicilio" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Codice A.S.L.</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslDomicilioCodice }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioniAsl.aslDomicilioCodice"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">A.S.L.</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslDomicilioDenominazione }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioniAsl.aslDomicilioDenominazione"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Ambito</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslDomicilioAmbito }}</span>
                                <b-form-select v-else v-model="jsonData.accettazioniAsl.aslDomicilioAmbito" :options="ambitiAslDomicilioOptions" text-field="text" value-field="value"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Distretto</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioniAsl.aslDomicilioDistretto }}</span>
                                <b-form-select v-else v-model="jsonData.accettazioniAsl.aslDomicilioDistretto" :options="distrettiAslDomicilioOptions" value-field="codiceDistretto" text-field="descrizione"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-card class="sa-card sa-card-border" header="Altre info" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Numero di Telefono</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.telefono }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.telefono"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">E-Mail</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.email }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.email"></b-form-input>
                            </b-col>
                            <!--     <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Scadenza Domicilio Sanitario</label>
                                <span v-if="isAccettazioneCampiEdit">{{ formatDate(jsonData.dataScadenzaDomicilioSanitario) }}</span>
                                <date-picker v-else format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataScadenzaDomicilioSanitario" type="date"></date-picker>
                            </b-col> -->
                            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                <label class="sa-label-data">Medico curante</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.medicoCurante }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.medicoCurante"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Medico Curante Telefono</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.medicoCuranteTelefono }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.medicoCuranteTelefono"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">E-Mail medico curante</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.emailMedicoCurante }}</span>
                                <b-form-input v-else v-model="jsonData.accettazioneAnagrafica.emailMedicoCurante"></b-form-input>
                            </b-col>
                            <!-- 
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Non Autonomo</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.nonAutonomo }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.nonAutonomo" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="nonAutonomoOptions"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Decreto Invalidità</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.decretoInvalidita }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.decretoInvalidita" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="decretoInvaliditaOptions"></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Struttura di Provenienza</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.strutturaProvenienza }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.strutturaProvenienza" class="mb-2 mr-sm-2 mb-sm-0" :options="strutturaProvenienzaOptions" :value="null" value-field="codice" text-field="descrizione" required></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Titolo di Studio</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.titoloStudio }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.titoloStudio" class="mb-2 mr-sm-2 mb-sm-0" :options="titoloStudioOptions" :value="null" value-field="codice" text-field="descrizione" required></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Tipo Documento</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.tipoDocumento }}</span>
                                <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.tipoDocumento" class="mb-2 mr-sm-2 mb-sm-0" :options="tipoDocumentoOptions" :value="null" value-field="codice" text-field="descrizione" required></b-form-select>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Numero Documento</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.numeroDocumento }}</span>
                                <b-form-input v-else v-model="jsonData.numeroDocumento"></b-form-input>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Data Rilascio</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.dataRilascioDocumento }}</span>
                                <date-picker v-else format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataRilascioDocumento" type="date"></date-picker>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Data Scadenza</label>
                                <span v-if="isAccettazioneCampiEdit">{{ formatDate(jsonData.dataScadenzaDocumento) }}</span>
                                <date-picker v-else format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataScadenzaDocumento" type="date"></date-picker>
                            </b-col> -->
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-card class="sa-card sa-card-border" header="Diagnosi e Note" header-tag="header" footer-tag="footer" title="">
                        <b-row>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Diagnosi in Ingresso</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.diagnosiIngresso }}</span>
                                <b-form-textarea v-else v-model="jsonData.diagnosiIngresso" placeholder="" rows="7"></b-form-textarea>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Note</label>
                                <span v-if="isAccettazioneCampiEdit">{{ jsonData.accettazioneAnagrafica.note }}</span>
                                <b-form-textarea v-else v-model="jsonData.accettazioneAnagrafica.note" id="textarea-auto-height" placeholder="" rows="7"></b-form-textarea>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>

    <!--    </div> -->
</template>
<script>
import axios from "axios";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: {},
    props: { isPageGestioneOspite: { type: Boolean, default: false } },

    data() {
        return {
            pathResource: "/rsaaccettazioni",
            pathResourcePresidio: "/strutturepresidi",
            pathResourceComuniByCodiceIstat: "/comuni/istat",
            pathResourcePersoneRifermineto: "/rsapersoneriferimento",
            pathResourceRegimi: "/accettazioneregimi",
            pathResourceStrutture: "/strutture",
            pathResourcePresidi: "/strutturepresidi",
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",
            pathResourceRegioni: "/regioni",
            pathResourceComune: "/comuni/istat",
            pathResourceAsl: "/asl/comune",
            pathResourceSettingsPresidi: "/rsasettingspresidi",
            pathResourceIdentificativo: "/anagraficaidentificativo",
            pathResourceStruttureProvienza: "/rsastruttureprovenienza",
            pathResourceTitoliStudio: "/rsatitolistudio",
            pathResourceAmbiti: "/serviziambiticomuni",
            pathResourceDistretti: "/servizidistretticomuni",
            showModalLoading: false,
            listKey: 0,
            rows: 0,
            perPage: 50,
            currentPage: 1,
            contatore: 0,
            id: null,
            presidio: "",
            comuneNascita: "",
            comuneResidenza: "",
            comuneDomicilio: "",
            activeTabIndex: 0,
            btnModificaAccettazione: true,
            btnAnnullaModificaAccettazione: false,
            btnSalvaModificaAccettazione: false,
            isAccettazioneCampiEdit: true,
            strutturaOptions: [],
            presidiOptions: [],
            regimiOptions: [],
            settingsPresidiOptions: [],
            provinceResidenzaOptions: [{ codice: null, provincia: "-Seleziona Provincia-" }],
            provinceDomicilioOptions: [{ codice: null, provincia: "-Seleziona Provincia-" }],
            comuniResidenzaOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            comuniDomicilioOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            comuniNascitaOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            ambitiAslDomicilioOptions: [{ text: "- Seleziona Valore -", value: null }],
            ambitiAslResidenzaOptions: [{ text: "- Seleziona Valore -", value: null }],
            distrettiAslDomicilioOptions: [{ descrizione: "- Seleziona Valore -", codiceDistretto: null }],
            distrettiAslResidenzaOptions: [{ descrizione: "- Seleziona Valore -", codiceDistretto: null }],
            jsonData: {
                codiceStruttura: null,
                idPresidio: null,
                numero: null,
                note: null,
                regime: null,
                idPrenotazione: null,
                accettazioneStruttura: {},
                accettazionePresidio: {},
                accettazioneAnagrafica: {
                    idAccettazione: null,
                    tipo: null,
                    identificativo: null,
                    tipoIdentificativo: null,
                    cognome: null,
                    nome: null,
                    dataNascita: null,
                    provinciaNascita: null,
                    comuneNascitaCodiceIstat: null,
                    sesso: null,
                    regioneResidenza: null,
                    provinciaResidenza: null,
                    comuneResidenzaCodiceIstat: null,
                    indirizzoResidenza: null,
                    capResidenza: null,
                    regioneDomicilio: null,
                    provinciaDomicilio: null,
                    comuneDomicilioCodiceIstat: null,
                    indirizzoDomicilio: null,
                    capDomicilio: null,
                    note: null,
                    medicoCurante: null,
                    codiceFiscaleMedicoCurante: null, //non a video
                    telefono: null,
                    email: null,
                    emailMedicoCurante: null,
                },
                accettazioniAsl: {},
            },
            decretoInvaliditaOptions: [
                { value: null, text: "- SI / NO -" },
                { value: "SI", text: "Si" },
                { value: "NO", text: "No" },
            ],
            nonAutonomoOptions: [
                { value: null, text: "- SI / NO -" },
                { value: "SI", text: "Si" },
                { value: "NO", text: "No" },
            ],
            titoloStudioOptions: [],
            strutturaProvenienzaOptions: [],
        };
    },
    mounted() {
        let me = this;
        if (this.$route.params.id) {
            me.id = this.$route.params.id;
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        setId(id) {
            let me = this;
            if (id) {
                me.id = id;
            }
            me.loadData();
            if (!me.isAccettazioneCampiEdit) {
                me.isAccettazioneCampiEdit = true;
                me.btnModificaAccettazione = true;
                me.btnAnnullaModificaAccettazione = false;
                me.btnSalvaModificaAccettazione = false;
            }
        },
        loadData() {
            let me = this;
            this.$emit("beforeLoadData");
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.loadPresidio();
                    me.loadComuneNascita();
                    me.loadComuneResidenza();
                    me.loadComuneDomicilio();
                    this.$emit("afterLoadData");
                })
                .catch((error) => {
                    console.log(error);
                    this.$emit("afterLoadData");
                });
        },
        loadPresidio() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidio + "/" + me.jsonData.idPresidio;
            axios
                .get(link)
                .then((response) => {
                    me.presidio = response.data.data.denominazione;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadComuneNascita() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuniByCodiceIstat + "/" + me.jsonData.accettazioneAnagrafica.comuneNascitaCodiceIstat;
            axios
                .get(link)
                .then((response) => {
                    me.comuneNascita = response.data.data.comune;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadComuneResidenza() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuniByCodiceIstat + "/" + me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat;
            axios
                .get(link)
                .then((response) => {
                    me.comuneResidenza = response.data.data.comune;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadComuneDomicilio() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuniByCodiceIstat + "/" + me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat;
            axios
                .get(link)
                .then((response) => {
                    me.comuneDomicilio = response.data.data.comune;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onClickSalvaModificheAccettazione() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultSaveResponse, me.resultSaveError);
        },
        resultSaveResponse() {
            let me = this;
            if (!me.btnModificaAccettazione) {
                me.isAccettazioneCampiEdit = true;
                me.btnModificaAccettazione = true;
                me.btnAnnullaModificaAccettazione = false;
                me.btnSalvaModificaAccettazione = false;
            }

            me.loadData();
        },
        resultSaveError(error) {
            UtilityMixin.methods.messaggeBoxError(this, error);
        },
        onClickModificaAccettazione() {
            let me = this;
            me.btnModificaAccettazione = !me.btnModificaAccettazione;
            me.isAccettazioneCampiEdit = !me.isAccettazioneCampiEdit;
            me.btnAnnullaModificaAccettazione = !me.btnAnnullaModificaAccettazione;
            me.btnSalvaModificaAccettazione = !me.btnSalvaModificaAccettazione;
            me.loadStrutture();
            me.loadPresidi(me.jsonData.codiceStruttura);
            me.loadSettingsPresidi(me.jsonData.idPresidio);
            me.loadRegimi();
            me.loadProvince();
            me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaResidenza, "residenza");
            me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaDomicilio, "domicilio");
            me.loadAmbitiAsl(me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
            me.loadAmbitiAsl(me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat, "domicilio");
            me.loadDistrettiAsl(me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
            me.loadDistrettiAsl(me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat, "domicilio");
            me.loadTipoDocumento();
            me.loadTitoliStudio();
            me.loadStruttureProvienza();
        },
        onClickAnnullaModificaAccettazione() {
            let me = this;
            me.btnModificaAccettazione = !me.btnModificaAccettazione;
            me.isAccettazioneCampiEdit = !me.isAccettazioneCampiEdit;
            me.btnAnnullaModificaAccettazione = !me.btnAnnullaModificaAccettazione;
            me.btnSalvaModificaAccettazione = !me.btnSalvaModificaAccettazione;
            me.loadData();
        },
        loadStrutture() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStrutture, {}, me.resultLoadStrutturaResponse, me.resulLoadStrutturaError);
        },
        resultLoadStrutturaResponse(response) {
            let me = this;
            me.strutturaOptions = [];
            me.strutturaOptions = response.data.data;

            if (me.strutturaOptions.length === 1) {
                me.jsonData.codiceStruttura = me.strutturaOptions[0].codiceStruttura;
                me.loadPresidi(me.strutturaOptions[0].id);
            } else {
                me.strutturaOptions.unshift({
                    codiceStruttura: null,
                    denominazione: "-Seleziona Struttura-",
                });
            }
        },
        resulLoadStrutturaError(error) {
            console.log(error);
        },
        onChangeStruttura(value) {
            let me = this;
            // let struttura = {};
            // me.strutturaOptions.forEach((element) => {
            //     if (element.codiceStruttura === value) {
            //         struttura = element;
            //         me.loadPresidi(struttura);
            //     }
            // });
            me.loadPresidi(value);
        },
        loadPresidi(codiceStruttura) {
            let me = this;
            me.presidiOptions = [];
            let struttura = {};

            me.strutturaOptions.forEach((element) => {
                if (element.codiceStruttura === codiceStruttura) {
                    struttura = element;
                }
            });
            UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, { idStruttura: struttura.id }, me.resultLoadPresidiResponse, me.resultLoadPresidiError);
        },
        resultLoadPresidiResponse(response) {
            let me = this;
            me.presidiOptions = response.data.data.list;
            if (me.presidiOptions.length === 1) {
                me.jsonData.idPresidio = me.presidiOptions[0].id;
                // me.loadSettingsPresidi(me.jsonData.idPresidio);
            } else {
                me.presidiOptions.unshift({
                    id: null,
                    denominazione: "-Seleziona Presidio-",
                });
            }
            if (me.jsonData.idPresidio !== null) {
                me.loadSettingsPresidi(me.jsonData.idPresidio);
            }
        },
        resultLoadPresidiError(error) {
            console.log(error);
        },
        onChangePresidio(value) {
            let me = this;
            if (value) {
                me.loadSettingsPresidi(value);
            }
        },
        loadRegimi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegimi;
            (me.regimiOptions = []),
                axios
                    .get(link)
                    .then((response) => {
                        me.regimiOptions = response.data.data.list;
                        me.regimiOptions.unshift({ codice: null, descrizione: "-Seleziona Regime-" });
                    })
                    .catch((error) => {
                        console.log("Il servizio dei regimi ha datao errore: " + error.response.status);
                    });
        },
        loadSettingsPresidi(id) {
            let me = this;
            me.settingsPresidiOptions = [];
            let params = { idPresidio: id };
            UtilityMixin.methods.loadDataResources(me.pathResourceSettingsPresidi, params, me.resultResponseSettings, me.resultErrorSettings);
        },
        resultResponseSettings(response) {
            let me = this;
            if (response.data.data.list.length === 0) {
                me.jsonData.settingCodice = null;
                me.jsonData.settingDescrizione = null;
                me.settingsPresidiOptions.unshift({ codice: null, setting: "-Seleziona Setting-" });
            } else {
                me.settingsPresidiOptions = response.data.data.list;
                if (me.settingsPresidiOptions.length === 1) {
                    me.jsonData.settingCodice = me.settingsPresidiOptions[0].codice;
                    me.jsonData.settingDescrizione = me.settingsPresidiOptions[0].setting;
                } else {
                    me.settingsPresidiOptions.unshift({ codice: null, setting: "-Seleziona Setting-" });
                }
            }
        },
        resultErrorSettings(response) {
            UtilityMixin.methods.messaggeBoxError(this, response);
        },
        onChangeSettingCodice(value) {
            let me = this;
            me.settingsPresidiOptions.forEach((element) => {
                if (element.codice === value) {
                    me.jsonData.settingDescrizione = element.setting;
                }
            });
        },
        loadProvince() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios.get(link, { params: me.filtro }).then((response) => {
                response.data.data.forEach((provincia) => {
                    me.provinceResidenzaOptions.push(provincia);
                    me.provinceDomicilioOptions.push(provincia);
                    //  me.loadComuni();
                });
            });
        },
        onChangeProvinciaResidenza(provincia) {
            let me = this;
            me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat = null;
            me.comuniResidenzaOptions = [];
            me.comuniResidenzaOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(provincia, "residenza");
            //  me.setDomicilio();
        },
        onChangeComuneResidenza(value) {
            let me = this;
            me.loadCap(value, "residenza");
            me.loadAsl(value, "residenza");
            me.loadDistrettiAsl(value, "residenza");
            me.loadAmbitiAsl(value, "residenza");
            //  me.setDomicilio();
        },
        onInputComuneDomicilio(value) {
            let me = this;
            me.loadCap(value, "domicilio");
            me.loadAsl(value, "domicilio");
            me.loadDistrettiAsl(value, "domicilio");
            me.loadAmbitiAsl(value, "domicilio");
        },

        loadCap(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComune + "/" + codiceIstat;
            if (codiceIstat) {
                axios
                    .get(link)
                    .then((response) => {
                        switch (destination) {
                            case "residenza":
                                me.jsonData.accettazioneAnagrafica.capResidenza = response.data.data.cap;
                                break;
                            case "domicilio":
                                me.jsonData.accettazioneAnagrafica.capDomicilio = response.data.data.cap;
                                break;
                        }
                    })
                    .catch((error) => {
                        console.log("Il servizio ha dato errore: " + error.response.status);
                    });
            }
        },
        loadAsl(codiceIstat, destination) {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourceAsl;
            let params = { istatComune: codiceIstat };
            if (codiceIstat) {
                axios
                    .get(link, { params: params })
                    .then((response) => {
                        if (response.data.data !== null) {
                            switch (destination) {
                                case "residenza":
                                    me.jsonData.accettazioniAsl.aslResidenzaCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    me.jsonData.accettazioniAsl.aslResidenzaDenominazione = response.data.data.denominazione;
                                    break;
                                case "domicilio":
                                    me.jsonData.accettazioniAsl.aslDomicilioCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    me.jsonData.accettazioniAsl.aslDomicilioDenominazione = response.data.data.denominazione;
                                    break;
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("Il servizio delle ASL ha datao errore: " + error.response.status);
                    });
            }
        },

        onInputProvinciaDomicilio(provincia) {
            let me = this;
            me.comuniDomicilioOptions = [];
            me.comuniDomicilioOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(provincia, "domicilio");
        },
        loadComuni(sigla, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuni + "/" + sigla;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((comune) => {
                        switch (destination) {
                            case "nascita":
                                me.comuniNascitaOptions.push(comune);
                                break;
                            case "residenza":
                                me.comuniResidenzaOptions.push(comune);
                                break;
                            case "domicilio":
                                me.comuniDomicilioOptions.push(comune);
                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log("Il servizio dei comuni ha datao errore: " + error.response.status);
                });
        },

        loadTitoliStudio() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTitoliStudio, {}, me.resultResponseTitoliStudio, me.resultErrorTitoliStudio);
        },
        resultResponseTitoliStudio(response) {
            let me = this;
            me.titoloStudioOptions = response.data.data.list;
            me.titoloStudioOptions.unshift({ codice: null, descrizione: "- Seleziona Titolo di Studio -" });
        },
        resultErrorTitoliStudio(error) {
            console.log(error);
        },
        loadStruttureProvienza() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStruttureProvienza, {}, me.resultResponseStruttureProvenienza, me.resultErrorStruttureProvenienza);
        },
        resultResponseStruttureProvenienza(response) {
            let me = this;
            me.strutturaProvenienzaOptions = response.data.data.list;
            me.strutturaProvenienzaOptions.unshift({ codice: null, descrizione: "- Seleziona Struttura di Provenienza -" });
        },
        resultErrorStruttureProvenienza(error) {
            console.log(error);
        },
        loadTipoDocumento() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceIdentificativo;
            me.tipiIdentificativoOptions = [];
            axios
                .get(link)
                .then((response) => {
                    me.tipoDocumentoOptions = response.data.data;
                    me.tipoDocumentoOptions.unshift({ codice: null, descrizione: "-Seleziona Tipo Documento-" });
                })
                .catch((error) => {
                    console.log("Il servizio identificativi ha datao errore: " + error.response.status);
                });
        },
        loadDistrettiAsl(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDistretti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    //      response.data.data.list.forEach((element) => {
                    switch (destination) {
                        case "residenza":
                            me.distrettiAslResidenzaOptions = [];
                            //me.distrettiAslResidenzaOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                            me.distrettiAslResidenzaOptions = response.data.data.list;
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazioniAsl.aslResidenzaDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            me.distrettiAslResidenzaOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
                            break;
                        case "domicilio":
                            me.distrettiAslDomicilioOptions = [];
                            me.distrettiAslDomicilioOptions = response.data.data.list; //.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazioniAsl.aslDomicilioDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            me.distrettiAslDomicilioOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
                            break;
                    }
                    //  });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.data);
                });
        },
        loadAmbitiAsl(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbiti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    response.data.data.list.forEach((element) => {
                        switch (destination) {
                            case "residenza":
                                me.ambitiAslResidenzaOptions = [];
                                me.ambitiAslResidenzaOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                                console.log(response.data.data.list.length);
                                if (response.data.data.list.length === 1) {
                                    me.jsonData.accettazioniAsl.aslResidenzaAmbito = response.data.data.list[0].codiceAmbito;
                                }
                                me.ambitiAslResidenzaOptions.unshift({ text: "- Seleziona Valore -", value: null });
                                break;
                            case "domicilio":
                                me.ambitiAslDomicilioOptions = [];
                                me.ambitiAslDomicilioOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                                if (response.data.data.list.length === 1) {
                                    me.jsonData.accettazioniAsl.aslDomicilioAmbito = response.data.data.list[0].codiceAmbito;
                                }
                                me.ambitiAslDomicilioOptions.unshift({ text: "- Seleziona Valore -", value: null });
                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.data);
                });
        },
    },
};
</script>
